import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IBottomNavigation } from 'common/models/bottom-nav';
import { IBranchDetails, SaleSteps, EventTypes } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  branchModalShowedFirstTime = false;
  branchChange = new Subject<IBranchDetails>();
  branchChangeState = this.branchChange.asObservable();
  setBranch = new Subject<IBranchDetails>();
  branchEditable = new Subject<boolean>();
  bottomNavData = new Subject<IBottomNavigation>();
  bottomNavClick = new Subject<{ eventType?: EventTypes, currentStep?: SaleSteps }>();
  bottomNavDisableContinue = new BehaviorSubject<boolean>(false);
  programTypeChanged = new Subject<boolean>();

  // Observable string sources
  private emitErrorSource = new Subject<any>();
  // Observable string streams
  errorEmitted$ = this.emitErrorSource.asObservable();
  // Service message commands
  emitError(change: any) {
    this.emitErrorSource.next(change);
  }
}
